export default __webpack_public_path__ + "static/media/italic_icon_white.99adc23f.svg";